import { yupResolver } from '@hookform/resolvers/yup';
import { useForm as useHookForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { getNightsCount } from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/ChronologicalPickers/utils';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

import { useAccomodationWizardContext } from '../../../context';
import type { TFormValues } from '../../types';
import { getSuggestedAreaFormDefaultValues } from './functions';
import { suggestedAreaValidationSchema } from './validation';

export const useSuggestedAreaForm = () => {
  const {
    activeAreaPage,
    data: { default: accommodation },
    isSuggestedArea,
  } = useAccomodationWizardContext();

  const organizedBy = useSelector(itineraryScheduleTypeSelector);

  const range = organizedBy === 'days' ? accommodation.daysRange : accommodation.datesRange;
  const nightsCount = getNightsCount(range.start!, range.end || undefined); // TODO types mistmatch

  const methods = useHookForm<TFormValues>({
    mode: 'onTouched',
    defaultValues: getSuggestedAreaFormDefaultValues({
      areaPage: isSuggestedArea ? activeAreaPage : undefined,
      accommodation,
      organizedBy,
    }),
    resolver: yupResolver(suggestedAreaValidationSchema),
  });

  const isDisabled = !methods.formState.isValid;

  return { methods, nightsCount, isDisabled };
};
